// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-node_modules_angular_flex-layout_fesm2020_angular-flex-layout_mjs":"6eb5b56d8f78b2ee","src_app_features_auto-registration_auto-registration_module_ts":"182aad7293532413","src_app_features_business-details_business-details_module_ts":"b404c9b67852a54b"}[chunkId] + ".js";
};